import { ZollSupportTicketConstants } from './zollSupportTicket.constants'
import { IZollSupportTicketAction, IZollSupportTicketState } from './zollSupportTicket.types'

export const emailOption = {
  id: 1,
  name: 'Email',
}

export const preferredContactMethodOptions = [
  emailOption,
  {
    id: 2,
    name: 'Phone Number',
  },
]

export const initialZollSupportTicketState: IZollSupportTicketState = {
  emailAddress: '',
  phoneNumber: '',
  questionOrProblem: '',
  showModal: false,
  isLoading: false,
  ticketId: null,
  preferredContactMethod: emailOption,
}

export function zollSupportTicketReducer(
  state: IZollSupportTicketState = initialZollSupportTicketState,
  action: IZollSupportTicketAction
): IZollSupportTicketState {
  switch (action.type) {
    case ZollSupportTicketConstants.SET_EMAIL_ADDRESS:
      return { ...state, emailAddress: action.emailAddress }
    case ZollSupportTicketConstants.SET_PHONE_NUMBER:
      return { ...state, phoneNumber: action.phoneNumber }
    case ZollSupportTicketConstants.SET_PREFERRED_CONTACT_METHOD:
      return { ...state, preferredContactMethod: action.preferredContactMethod }
    case ZollSupportTicketConstants.SET_QUESTION_OR_PROBLEM:
      return { ...state, questionOrProblem: action.questionOrProblem }
    case ZollSupportTicketConstants.SET_SHOW_MODAL:
      return { ...state, showModal: action.showModal }
    case ZollSupportTicketConstants.SET_IS_LOADING:
      return { ...state, isLoading: action.isLoading }
    case ZollSupportTicketConstants.SET_TICKET_ID:
      return { ...state, ticketId: action.ticketId }
    default:
      return state
  }
}
